import { axiosHelper } from 'Services/AxiosHelper';
import { GetTownListOtherModel } from 'Models';
import { getTownListOtherReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'b2c.RIGetTownList';

const getTownListOther = async (params: getTownListOtherReqBodyData): Promise<GetTownListOtherModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default getTownListOther;
